export default (): null => null;



// WEBPACK FOOTER //
// ./src/utils/returnNull.js